import { Dispatch, SetStateAction } from 'react';

import { AccountProfile } from '#/api/account';

import { AsyncResult } from '#/utils/types';

import { AccountProfileState } from './account-profile-state';
import { AccountProfileService } from './account-profile-context-service';

interface AccountProfileUpdate
  extends Pick<AccountProfile, 'username' | 'is_username_private'> {}

export interface AccountProfileActions {
  readonly update: (profile: AccountProfileUpdate) => AsyncResult<void>;
}

export function createActions(
  setState: Dispatch<SetStateAction<AccountProfileState>>,
  service: AccountProfileService,
): AccountProfileActions {
  return {
    update: async (profile) => {
      const result = await service.update(profile);
      if (result.ok) {
        setState((state) => ({
          ...state,
          profile: result.data,
        }));
      }
      return { ...result, data: undefined };
    },
  };
}
